'use client';

import React, { useEffect, useState } from 'react';
import getIpFromCloudflareClient from 'utilities/src/getIpFromCloudflareClient';
import Script from './Script';

export default function WarmlyScript() {
  const [isUS, setIsUS] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function checkCountry() {
      try {
        const cfData = await getIpFromCloudflareClient();
        if (cancelled) return;
        setIsUS(cfData?.loc === 'US');
      } catch {
        if (cancelled) return;
        setIsUS(false);
      }
    }

    checkCountry();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!isUS) return null;

  return (
    <Script
      id="warmly-script-loader"
      strategy="afterInteractive"
      src="https://opps-widget.getwarmly.com/warmly.js?clientId=c2961afcdef47349815bbbfe6f34b85e"
      defer
    />
  );
}
